import React from "react";
import { Box, Button, Modal, Typography } from "@mui/material";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  borderRadius: "16px",
  boxShadow: 24,
  p: 4,
  textAlign: "center",
};
const ModalEnviarSms = ({ handleSubmit, titulo, mensaje, onClose, open }) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={style}>
        <Typography variant="h4" component="h1" sx={{ fontWeight: 700, mb: 2 }}>
          {titulo}
        </Typography>

        <Typography variant="body1" sx={{ color: "text.secondary", mb: 4 }}>
          {mensaje}
        </Typography>

        <Box sx={{ display: "flex", justifyContent: "space-between", gap: 2 }}>
          <Button
            variant="outlined"
            color="error"
            onClick={onClose}
            sx={{ flex: 1, fontWeight: 600 }}
          >
            Volver
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit}
            sx={{ flex: 1, fontWeight: 600 }}
          >
            Enviar
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ModalEnviarSms;
